// React and Hot Loader
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

import { browserHistory as history } from 'react-router';

require('./styles/less/petclinic.less');

// The Application
import Root from './Root';

// Render Application
const mountPoint = document.getElementById('mount');
if (!mountPoint) {
  console.error('Mount point not found! Make sure index.html has <div id="mount"></div>');
} else {
  try {
    ReactDOM.render(
      <AppContainer><Root history={history}/></AppContainer>,
      mountPoint
    );
  } catch (error) {
    console.error('Error rendering React app:', error);
    mountPoint.innerHTML = '<div style="padding: 20px; color: red;"><h2>Application Error</h2><p>Check the browser console for details.</p><pre>' + error.toString() + '</pre></div>';
  }
}

declare var module: any;
if (module.hot) {
  module.hot.accept('./Root', () => {
    const NextApp = require('./Root').default;
    ReactDOM.render(
      <AppContainer>
        <NextApp history={history} />
      </AppContainer>,
      mountPoint
    );
  });
}
